<template>
  <div class="state8">
    <lib></lib>
  </div>
</template>

<script>
import lib from "../../questionlib/index.vue";

export default {
  name: "QuestionsIndex",
  components: { lib }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/examination-page.scss";
</style>
